import service from '@/services/restaurant/zone'
import ObjectID from 'bson-objectid'

const getDefaultState = () => ({
  zone: { name: '', location: '', state: true, restaurant: { _id: '' }, table: [] },
  table: { name: '', number: '', state: true, seats: 0, isAvailable: true },
  list: [], // zone list
  currentRow: null,
  saved: 'null'
})

export const state = () => getDefaultState()

export const mutations = {
  RESET_STATE: state => Object.assign(state, getDefaultState()),
  RESET: state => (state.zone = { ...getDefaultState().zone }),
  RESET_TABLE: state => (state.table = { ...getDefaultState().table }),
  SET_ROW: (state, row) => (state.currentRow = row),
  SET: (state, obj) => {
    state.zone = obj
    state.saved = true
  },
  SET_TABLE: (state, obj) => {
    state.table = obj
  },
  SET_LIST: (state, obj) => (state.list = obj),
  UPDATE_LIST: (state, obj) => {
    const nObj = state.list.find(e => e._id === obj._id)
    if (!nObj) state.list = [obj, ...state.list]
    else Object.keys(nObj).forEach(i => (nObj[i] = obj[i]))

    state.saved = true
  },
  DELETE_LIST: (state, { obj }) => {
    state.list = state.list.filter(e => e._id !== obj._id)
  },
  SAVE_CHANGES: (state, obj) => {
    state.zone = obj
    state.saved = false
  }
}

export const actions = {
  create: async ({ commit, rootGetters, state }, input) => {
    return service
      .create({
        ...input,
        table: input.table.map(e => ({ ...e, seats: Number(e.seats) })),
        emisor: {
          _id: await rootGetters['facturacion/emisorStore/get_Id']
        }
      })
      .then(result => {
        commit('UPDATE_LIST', {
          ...input,
          _id: result._id
        })

        state.zone._id = result._id

        return result
      })
  },
  addTable: async ({ dispatch, state }, input) => {
    const nObj = state.zone.table.find(e => e._id === input._id)

    if (!nObj) {
      input._id = new ObjectID()
      state.zone.table = [input, ...state.zone.table]
    } else Object.keys(nObj).forEach(i => (nObj[i] = input[i]))

    dispatch('create', state.zone)
  },

  deleteTable: async ({ dispatch, state }, input) => {
    state.zone.table = state.zone.table.filter(e => {
      const check = input.items.includes(e._id)

      return !check
    })

    await dispatch('create', state.zone)
    return true
  },

  readById: async ({ commit }, input) => commit('SET', input),
  readTable: async ({ commit }, input) => commit('SET_TABLE', input),
  // resetList: ({ state }) => (state.list = []),
  readAllByEmisor: async ({ commit, state, dispatch, rootGetters }, force = false) => {
    if (state.list.length && !force) return state.list

    state.list = []

    return service.readAllByEmisor(rootGetters['facturacion/emisorStore/get_Id']).then(result => {
      commit('SET_LIST', result)

      return true
    })
  },
  delete: ({ commit }, { items }) =>
    service.delete(items).then(result => {
      result.forEach(i => {
        if (i.state) commit('DELETE_LIST', { obj: i })
      })
      return result
    }),

  saveChanges: ({ commit }, input) => commit('SAVE_CHANGES', input)
}
